import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["status-badge d-inline-block d-lg-block", _ctx.getBadgeClass()])
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.getTranslatedStatus()), 1)
  ], 2))
}